import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate } from "react-router-dom";
import usuariosServices from '../../services/usuariosServices';
import resourcesServices from '../../services/resourcesServices';
import { InputContext } from '../../contexts/InputContext';
import MessageModal from '../../container/MessageModal';
import { BsFillCaretDownFill, BsFillCaretUpFill } from "react-icons/bs";
import {errorClassification} from '../../errorHandler';

const ListaUsuarios = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)

  const [usuarios, setUsuarios] = useState([]);
  const [roles, setRoles] = useState([]);
  const [query, setQuery] = useState("");
  const [renderHTML, setRenderHTML] = useState(false);
  const [filtroRol, setFiltroRol] = useState('');
  const [header, setHeader] = useState([]);

  const [columnas, setColumnas] = useState([
    {nombre: "Nombre", nombreCampo: "nombre", ordenar: false},
    {nombre: "Apellido", nombreCampo: "apellido", ordenar: false},
    {nombre: "Email", nombreCampo: "email", ordenar: false},
    {nombre: "Documento", nombreCampo: "documento_identidad", ordenar: false},
    {nombre: "Rol", ordenar: false},
    {nombre: "Fecha de Alta", nombreCampo: "created_at", ordenar: false},
    {nombre: "Activado", nombreCampo: "activo", ordenar: false},
    {nombre: "Acciones", ordenar: false},
    ]);
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("desc");

  // modal messages
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');
  const handleShowModal = (message) => {setModalBody(message); setShowModal(true)};
  const handleCloseModal = () => { setShowModal(false); setModalBody('') };

  useEffect(() => {
    fetchUsuarios();
    fetchRoles();
  }, []);

  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( (authInformation.autenticado === true) && (authInformation.rol === 'Admin' || authInformation.rol === 'Veedor')){
      setRenderHTML(true)
    } else if( (authInformation.autenticado === true) && (authInformation.rol !== 'Admin')){
      navigate(`/`);
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);

  const fetchUsuarios = async (sortBy='', q='', page=1, otro='')  => {
    try {
      const data = await resourcesServices.obtenerResources('usuarios', sortBy, {"query": q}, page, otro);

      if (page === 1) {
        setUsuarios(data.data);
      } else {
        setUsuarios([...usuarios, ...data.data]);
      }

      setHeader(data.headers);

      // setTotalPages(data.meta.total_pages);
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        alert(result.message)
      }
    }
  };

  const fetchRoles = async () => {
    try {
      const data = await resourcesServices.obtenerResources('usuarios/obtenerRoles');

      setRoles(data.data.concat("Todos"));
    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        alert(result.message)
      }
    }
  };

  const eliminarUsuario = async (usuario) => {
    try {
      if(window.confirm(`Está seguro que quiere eliminar a ${usuario.nombre}?`)){
        await usuariosServices.eliminarUsuario(usuario.id);

        const copiaUsuarios = [...usuarios];
        setUsuarios(copiaUsuarios.filter((usuarios) => usuarios.id !== usuario.id))
      }

    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        alert(result.message)
      }
    }
  };

  useEffect(() => {
    if(filtroRol!==null){
      obtenerPagina()
    }
  }, [filtroRol]);

  useEffect(() => {
    if(sortedColumn!==null){
      obtenerPagina(columnas[sortedColumn].nombreCampo + " " + sortOrder)
    }
  }, [sortedColumn, sortOrder]);


  const orderBy = (e, indice) => {
    e.preventDefault()

    if (sortedColumn === indice) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortedColumn(indice);
      setSortOrder("asc");
    }
  }

  const obtenerPagina = async (order='', page=1) => {
    if(filtroRol!==null){
      fetchUsuarios(order, query, page, 'rol=' + filtroRol)
    } else {
      fetchUsuarios(order, query, page, '')
    }
  };


  const handleFormSubmit = (e) => {
    e.preventDefault()

    obtenerPagina()
  }

  const listarUsuarios = usuarios && usuarios.map((usuario, index) => {
    return (
      <tr className={`${usuario.activo ? '' : 'table-danger'}`} key={index}>
        <td>{usuario.nombre}</td>
        <td>{usuario.apellido}</td>
        <td>{usuario.email}</td>
        <td>{usuario.documento_identidad}</td>
        <td>{usuario.rol}</td>
        <td>{usuario.fecha_alta}</td>
        <td>{usuario.activo ? 'SI' : 'NO'}</td>
        <td>
          {
            authInformation.rol === 'Veedor' ? (
              <Link className="btn btn-primary me-1" to={`/usuario/${usuario.id}`}>Ver</Link>
            ) : (
              <Link className="btn btn-primary me-1" to={`/usuario/${usuario.id}/edit`}>Editar</Link>
            )
          }

          <button className="btn btn-danger me-1" onClick={()=>eliminarUsuario(usuario)} >Eliminar</button>
        </td>
    </tr>
    )
  })

  const columnasTabla = () => {
    return (
      <tr>
        {
          columnas.map((col, index) => (
            <th scope="col" key={index}>
              {
                (col.ordenar === true) ? (
                  <a className='icon-link' onClick={(e) => orderBy(e, index)} href="#">{col.nombre}</a>
                ) : (
                  <>{col.nombre}</>
                )
              }
              {
                sortedColumn === index && (

                sortOrder === 'desc' ? (
                  <BsFillCaretDownFill />
                  ) : (
                  <BsFillCaretUpFill />
                  )
                )
              }
            </th>
          ))
        }
      </tr>
    )
  }

  return (
    <>
      <h1>Lista de usuarios</h1>
      {
        (renderHTML) && (
          <>
          <div className=''>
            Filtros:
            <div className="btn-group mb-1" role="group" aria-label="Basic radio toggle button group">
              {
                roles && roles.map((rol, index) => (
                  <div key={index} className='ms-1'>
                    <input
                      type="radio"
                      className="btn-check"
                      name={`radio${index}`}
                      id={`radio${index}`}
                      value={rol}
                      autoComplete="off"
                      checked={filtroRol === rol}
                      onChange={(e) => setFiltroRol(e.target.value)}
                      />
                    <label className="btn btn-outline-primary" htmlFor={`radio${index}`}>{rol}</label>
                  </div>
                ))
              }
            </div>

            <form className="row g-3" onSubmit={handleFormSubmit}>
              <div className="col-6"></div>
              <div className="col-4">
                <label htmlFor="staticEmail2" className="visually-hidden">Email</label>
                <input type="text" onChange={(e) => setQuery(e.target.value)} className="form-control" id="staticEmail2" value={query || ''} />
              </div>
              <div className="col-2">
                <button type="submit" className="btn btn-primary mb-3">Buscar</button>
              </div>
            </form>
          </div>

          <div className="table-responsive small">
            <table className="table table-striped table-sm">
              <thead>
                {columnasTabla()}
              </thead>
              <tbody>
                {listarUsuarios}
              </tbody>
            </table>
            {
                header["total-pages"] !== header["current-page"] && (
                  <div className='p-3'>
                    <button onClick={()=>obtenerPagina('', header["current-page"] + 1)} className='btn btn-success mt-3'>Ver más | {header["current-page"]} de {header["total-pages"]}</button>
                  </div>
                )
              }
          </div>
          </>
        )
      }
      <MessageModal
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        modalBody={modalBody}
     />
      </>

  );
};

export default ListaUsuarios;